import React, { useState } from "react";
import FormControl, { UploadPreviewFieldControl } from "components/FormControl";
import {
  GroupRow,
  Column,
  Row,
  TitleResult,
  ContainerButtons,
  TextInformationFile,
  ContainerResult,
  NumberSucces,
  ContainerUpload,
  TableHeader,
  ContainerTableHeader,
} from "./styles";

import { ACCEPTED_FILE_TYPES } from "constants/image";
import Title from "components/Layout/Page/Title/Title";
import { Button } from "@material-ui/core";
import { CancelButtonControl } from "components/FormControl/SubmitButtonControl/SubmitButtonControl";
import UnsuccesfullList from "./UnsuccesfullList";

import LoadingFile from "components/LoadingFile/LoadingFile";
import { useParams } from "react-router";
import ManualBadgeStore from "stores/ManualBadgeStore";

const ManualBadgeCsvForm = ({ onManageUsers, onSuccessfulUsersUpdate }) => {
  const [isDisableSave, setIsDisableSave] = useState(true);
  const [uploadFileStatus, setUploadFileStatus] = useState(false);
  const [showUploadInformation, setUploadInformation] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showUnsuccess, setShowUnsuccess] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [emailsFailWithReasons, setEmailsFailWithReasons] = useState([{}]);
  const [successfullUpload, setSuccessfullUpload] = useState<
    number | undefined
  >(undefined);
  const [emailsData, setEmailsData] = useState<string[]>([]);

  const manualBadge: {
    manualBadgeId: string;
  } = useParams();

  const renderCancelButton = ({ onClick }: { onClick: () => void }) => (
    <Button variant="outlined" color="primary" onClick={onClick}>
      Cancel
    </Button>
  );

  const handleManageUsersChange = value => {
    onManageUsers(value);
  };

  const handleSave = async (emailsData: string[]) => {
    try {
      await ManualBadgeStore.uploadUsersFile(
        manualBadge.manualBadgeId,
        emailsData,
      );
      await ManualBadgeStore.fetchManualBadge(manualBadge.manualBadgeId);
      await new Promise(resolve => setTimeout(resolve, 100));
      const successfulUsersAmount =
        ManualBadgeStore.manualBadge?.data.dataManualBadge
          .successfulUsersAmount;
      onSuccessfulUsersUpdate(successfulUsersAmount);
      handleManageUsersChange(false);
    } catch (error) {
      console.log("error", error);
    }
  };

  const updateShowSuccess = (showSuccessState: boolean) => {
    setShowSuccess(showSuccessState);
  };

  const updateShowUnSuccess = (showUnsuccessState: boolean) => {
    setShowUnsuccess(showUnsuccessState);
  };

  const updateFileStatus = (fileStatusState: boolean) => {
    setUploadFileStatus(fileStatusState);
  };

  const updateShowUpload = (uploadInformationState: boolean) => {
    setUploadInformation(uploadInformationState);
  };

  const disableSaveButton = (disableState: boolean) => {
    setIsDisableSave(disableState);
  };

  const updateEmailsFailed = (emailsFailed: any[]) => {
    setEmailsFailWithReasons(emailsFailed);
  };

  const updateLoadingState = (loadingState: boolean) => {
    setIsLoading(loadingState);
  };

  const updateSuccessfullUpload = (
    numberSuccessfullUpload: number | undefined,
  ) => {
    setSuccessfullUpload(numberSuccessfullUpload);
  };

  const updateEmailData = (emailsValid: string[]) => {
    setEmailsData(emailsValid);
  };

  return (
    <>
      <Title title={"User List"}></Title>
      <FormControl onSubmit={() => console.log("submit")}>
        <GroupRow>
          <Column width="30%">
            <Row>
              <ContainerUpload>
                <UploadPreviewFieldControl
                  badgeId={manualBadge.manualBadgeId}
                  updateStatus={updateFileStatus}
                  updateShowUpload={updateShowUpload}
                  updateShowSuccess={updateShowSuccess}
                  updateShowUnSuccess={updateShowUnSuccess}
                  name="ManualBadgeFile"
                  acceptedFiles={ACCEPTED_FILE_TYPES}
                  disableSaveButton={disableSaveButton}
                  emailsFailWithReasons={updateEmailsFailed}
                  successfullUploads={updateSuccessfullUpload}
                  setIsLoading={updateLoadingState}
                  updateEmails={updateEmailData}
                  required
                />
                {showUploadInformation && (
                  <>
                    {isLoading && <LoadingFile />}
                    {!isLoading && (
                      <TextInformationFile
                        style={{
                          color: uploadFileStatus ? "#3A843D" : "red",
                        }}
                      >
                        {uploadFileStatus
                          ? "* File loaded successfully."
                          : "* No badges were awarded, there was a problem with your file."}
                      </TextInformationFile>
                    )}
                  </>
                )}
              </ContainerUpload>
            </Row>
          </Column>
        </GroupRow>
        <Column width="100%">
          {uploadFileStatus && (
            <Row>
              {showSuccess && (
                <ContainerResult>
                  <TitleResult isSuccess={true}>
                    {" "}
                    Users successfully loaded{" "}
                  </TitleResult>
                  <NumberSucces>{successfullUpload}</NumberSucces>
                </ContainerResult>
              )}
              {showUnsuccess && (
                <ContainerResult>
                  <TitleResult isSuccess={false}>
                    Users unsuccessfully loaded{" "}
                  </TitleResult>
                  <ContainerTableHeader>
                    <TableHeader>Emails</TableHeader>
                    <TableHeader>Reason</TableHeader>
                  </ContainerTableHeader>
                  <UnsuccesfullList emailsWithReasons={emailsFailWithReasons} />
                </ContainerResult>
              )}
            </Row>
          )}
        </Column>
        <ContainerButtons>
          <CancelButtonControl
            render={renderCancelButton}
            onClick={() => handleManageUsersChange(false)}
          />
          <Button
            variant="contained"
            color="primary"
            disabled={isDisableSave}
            style={{ marginLeft: "20px" }}
            onClick={() => handleSave(emailsData)}
          >
            Save
          </Button>
        </ContainerButtons>
      </FormControl>
    </>
  );
};
export default ManualBadgeCsvForm;
